
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { dateFormatter } from "../_helpers/dateFormatter";
import { Container, Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDeleteLeft } from "@fortawesome/free-solid-svg-icons";

function KanbanJobCard({ jobDetails,
  onAssignInterviewKit,
  showAllInterviewKits,
  openInterviewKit,
  onScheduleInterviewClick,
  interviewKitsLoading,
  assignedInterviewKit,
  allInterviewKits,
  onJobShareClick,
  showSearch, onSearchInputChange,
  onSearch, searchInputRef, onToggleViewClick, listView, loading, userType }) {

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("jigsawUser"));
  const role = user?.user && user.user?.role;

  return (
    <Container>
      {loading ?
        <div className="text-center">
          <Spinner variant="primary" />
        </div> :
        <>
          <div className="border bg-white p-3 border-radius-10">
            <div className="d-flex justify-content-between  mb-2 align-items-start">
              <div>
                <h2 className="d-inline-block text-capitalize mr-3 mb-2">
                  {jobDetails?.data && jobDetails.data?.title}
                </h2>
                <p className="text-grey-4">{jobDetails?.data && jobDetails.data?.state_name},{" "}
                  {jobDetails?.data && jobDetails.data?.country_name}</p>
              </div>

              <div className="d-flex align-items-start justify-content-end">
                <button className="bg-transparent border-0" title="Share" onClick={onJobShareClick}>
                  <img src="/assets/images/share-icon.svg" alt="share" />
                </button>
                <div className="d-flex align-items-center flex-wrap justify-content-end">
                  {jobDetails?.data && jobDetails?.data?.event_assigned ? (
                    <span className="bg-grey-4 border rounded-lg d-inline-block px-2 py-1 text-capitalize mb-2 mb-md-0">
                      Event Assigned :
                      <strong className="">
                        {jobDetails?.data &&
                          jobDetails.data?.event_assigned &&
                          jobDetails.data.event_assigned?.title}
                      </strong>
                    </span>
                  ) : (
                    <button
                      className="btn btn-primary mr-md-1 mb-1 py-1 mb-md-0"
                      onClick={onScheduleInterviewClick}
                    >
                      Assign Event
                    </button>
                  )}
                  {role === "mentor" ?
                    jobDetails?.data && jobDetails.data?.assigned_assessment_kit !== null ? (
                      <span className="d-inline-block py-1 px-2 bg-grey-4 rounded-lg border ml-2 flex">
                        {assignedInterviewKit?.interview_kit_detail &&
                          assignedInterviewKit.interview_kit_detail?.title}
                      </span>
                    ) : (
                      <div className="position-relative ml-md-1">
                        <Dropdown>
                          <Dropdown.Toggle
                            className="no-dropdown-arrow px-0 py-0"
                            variant="primary"
                            id="dropdown-basic"
                          >
                            <button
                              className="btn btn-primary py-1"
                              onClick={openInterviewKit}
                            >
                              Assign Assessment Kit
                            </button>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {showAllInterviewKits ? (
                              <div>
                                {interviewKitsLoading ? (
                                  <div className="p-5 text-center">
                                    <Spinner
                                      animation="border"
                                      variant="primary"
                                      className="text-center"
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    {allInterviewKits && allInterviewKits.length > 0 ? (
                                      <ul className="mb-0">
                                        {Array.isArray(allInterviewKits) &&
                                          allInterviewKits.map((item, index) => (
                                            <li
                                              className="px-3 py-1"
                                              title={item?.title}
                                              key={index}
                                            >
                                              <div className="d-flex justify-content-between align-items-center">
                                                <div className="left font-weight-medium">
                                                  <h4
                                                    onClick={(e) => {
                                                      navigate(
                                                        `/create-assessment/${item.id}`
                                                      );
                                                    }}
                                                    className="d-inline-block mt-2 font-weight-medium"
                                                  >
                                                    <span className="text-capitalize">
                                                      {item?.title}
                                                    </span>
                                                  </h4>
                                                  <p className="text-capitalize text-grey-4 fs-smallest">
                                                    {item?.due_date}
                                                  </p>
                                                </div>

                                                <div>
                                                  <button
                                                    className="btn btn-primary p-2 ml-2"
                                                    onClick={() =>
                                                      onAssignInterviewKit(item?.id)
                                                    }
                                                  >
                                                    Assign
                                                  </button>
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                      </ul>
                                    ) : (
                                      <p className="text-danger pt-2">
                                        No assessment kits created.
                                      </p>
                                    )}
                                  </div>
                                )}{" "}
                              </div>
                            ) : null}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    ) : null}
                </div>
                {/* <button
          className="bg-transparent border-0 py-2 text-dark"
          title="Edit"
        >
          <img src="/assets/images/edit-grey.svg" alt="edit" />
        </button> */}
              </div>
            </div>

            <div className="d-flex align-items-center text-grey-4 mb-3">
              <span className="mr-4 font-weight-medium">
                <span className="text-grey-4 font-weight-normal">
                  {" "}
                  Total Candidates :{' '}<span className="text-dark font-weight-medium">{(jobDetails?.data && jobDetails.data?.total_candidates) || 0}{" "}</span>
                </span>
              </span>
            </div>
            <p className="skills fs-smallest mb-2">
              {Array.isArray(jobDetails?.data && jobDetails.data?.skill_names) &&
                jobDetails?.data && jobDetails.data?.skill_names && jobDetails.data.skill_names.length > 0 ? (
                <>
                  {Array.isArray(jobDetails?.data && jobDetails.data?.skill_names) &&
                    jobDetails?.data && jobDetails.data?.skill_names && jobDetails.data.skill_names.map((skill, i) => (
                      <span key={i} className="skill bg-grey-4 border rounded px-2 py-1  font-weight-medium mr-2 mb-2 text-capitalize">
                        {skill}
                      </span>
                    ))}
                  <p className="text-muted d-inline-block">
                    {Array.isArray(jobDetails?.data && jobDetails.data?.skill_names) &&
                      jobDetails?.data && jobDetails.data?.skill_names && jobDetails.data.skill_names.length > 6
                      ? "..."
                      : null}
                  </p>
                </>
              ) : (
                null
              )}
            </p>
            {userType !== "mentor" &&
              <p className="text-capitalize  pt-2 mb-0">
                {jobDetails?.data?.mentor_name !== null ? (
                  <span className="text-grey-4 font-weight-400">
                    Mentor Assign:{" "}
                    <span
                      className="cursor-pointer text-dark-2 font-weight-medium text-underline"
                      onClick={() => {
                        navigate(
                          `/view-mentor-profile/${jobDetails?.data && jobDetails.data?.mentor_job_application_id}`
                        );
                      }}
                    >
                      {jobDetails?.data && jobDetails.data?.mentor_name}
                    </span>
                  </span>
                ) : (
                  <span className="text-grey-4 font-weight-400">
                    Mentor Applied:{" "}
                    <span
                      className="cursor-pointer font-weight-medium bg-primary text-white rounded-lg px-2 py-1 ml-2  text-underline"
                      onClick={() =>
                        navigate(`/view-mentors-applied/${jobDetails?.data && jobDetails.data?.id}`, {
                          state: jobDetails?.data && jobDetails.data?.id,
                        })
                      }
                    >
                      {jobDetails.data?.total_mentors}{" "}
                    </span>
                  </span>
                )}
              </p>
            }
            <div className="d-flex justify-content-between pt-2">
              <p className="text-grey-4">
                Published on  {dateFormatter(jobDetails && jobDetails.data?.created)}
              </p>
              {role === "mentor" &&
                <a
                  href="/create-assessment"
                  className="text-primary ml-3 font-weight-medium"
                >
                  Create Assessment Kit
                </a>
              }
            </div>
          </div>
          <div className="d-flex custom-search-box mt-3 w-100 mb-3 mb-md-0 text-right justify-content-end">
            <div className="mr-2 d-flex mb-2">
              <button className="btn bg-grey-2 border border-radius-10 text-nowrap" onClick={onToggleViewClick}>
                {listView ?
                  "Switch to Kanban View" : "Swicth to List View"}</button>
            </div>
            <div className="search-box-with-icon bg-white mb-2"
              style={{ height: '42px' }}
            >
              <input
                type="text"
                className="form-control border-0 bg-transparent"
                placeholder="Search Candidates"
                onChange={(e) =>
                  onSearchInputChange(
                    e,
                    jobDetails && jobDetails.data?.id
                  )
                }
                ref={searchInputRef}
              />
              <div className="input-group-append">
                {showSearch ? (
                  <button
                    className="btn border-0 shadow-none p-2"
                    type="button"
                    onClick={onSearch}
                  >
                    <FontAwesomeIcon
                      icon={faDeleteLeft}
                      className="ml-2"
                    />
                  </button>
                ) : (
                  <button className="btn border-0 p-2" type="button">
                    <img
                      src="../assets/images/search-icon.png"
                      alt="search"
                    />
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      }
    </Container>
  );
}

export default KanbanJobCard;
